import { reducer as compliance } from "./compliance/slice";

export const reducer = {
  compliance,
};
